module.exports = __webpack_public_path__ + "static/media/branding.cfde4c98.png";